import * as React from "react";

const SettingsIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={className}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_2498_2071)"
    >
      <path d="M12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5"></path>
      <path d="M12.192 19.323h-.375L8.813 21a9.8 9.8 0 0 1-3.198-1.8l-.011-3.375a5 5 0 0 1-.188-.32l-2.988-1.701a9.3 9.3 0 0 1 0-3.606l2.985-1.697q.092-.162.188-.32l.015-3.374A9.8 9.8 0 0 1 8.813 3l3 1.677h.375l3-1.677a9.8 9.8 0 0 1 3.197 1.8l.012 3.375q.1.156.187.32l2.986 1.7a9.3 9.3 0 0 1 0 3.606l-2.985 1.697q-.091.162-.187.32l-.015 3.374A9.8 9.8 0 0 1 15.188 21z"></path>
    </g>
    <defs>
      <clipPath id="clip0_2498_2071">
        <path fill="#fff" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SettingsIcon;
